import { TOTAL_RETAIL } from "./formula-total-retail";
import { get } from "lodash";
import { ItemFields } from "constants/product-collection";
import { getMetricValuesFromOldBagData } from "./formula-helpers";
import { referenceMetricValueOrCompute, sumRowTotalRetailValues } from "../sibling-value-getter/getter";
import { MetricsKind } from "../types";
import { ColumnTypes } from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";
import { safeParseFloat } from "lib/number";

export const DOOR_PERCENTAGE_PLAN = ({ factoryOptions, getterParams }) => {
    const { node, column } = getterParams;
    const totalRetail = referenceMetricValueOrCompute(
        () => safeParseFloat(TOTAL_RETAIL({ factoryOptions, getterParams }), 0),
        getterParams,
        MetricsKind.TOTAL_RETAIL
    );

    const { useSize } = factoryOptions;

    // For grand total, this will always be 100
    if (totalRetail > 0 && column.getColDef().type === ColumnTypes.AllDimensionTotal) {
        return 100;
    }

    const grandTotalRowRetail = referenceMetricValueOrCompute(
        () => {
            if (getterParams.context.allocationBagRef?.allocationBag) {
                return sumRowTotalRetailValues(factoryOptions, getterParams);
            } else {
                let totalRetailCostForRow = 0;
                const { data } = getterParams;
                const { deliveryId, filteredDeliveriesForAssortmentSet, filteredDoorsForAssortmentSet } =
                    factoryOptions;

                /**
                 * Old allocation bag
                 */
                let cols: string[][] = [];
                const size: string = data.size;
                if (data.allocations && data.allocations.current) {
                    cols = data.allocations.current.r.map((r) => r.c);
                } else if (data.bulks && data.bulks.r) {
                    cols = data.bulks.r.map((r) => r.c);
                } else if (data.bulks && data.bulks.current && data.bulks.current.r) {
                    cols = data.bulks.current.r.map((r) => r.c);
                }
                cols.forEach((col) => {
                    const { currentDeliveryIdValue, doorIdValue, bulkCount, currentSize } =
                        getMetricValuesFromOldBagData(deliveryId, filteredDoorsForAssortmentSet, col, useSize, size);

                    // If there is a filter check to make sure this delivery or door is in that list
                    if (
                        filteredDeliveriesForAssortmentSet &&
                        !filteredDeliveriesForAssortmentSet.has(currentDeliveryIdValue)
                    ) {
                        return;
                    }

                    if (filteredDoorsForAssortmentSet && !filteredDoorsForAssortmentSet.has(doorIdValue)) {
                        return;
                    }

                    if (useSize && size !== currentSize) {
                        return;
                    }

                    const door = filteredDoorsForAssortmentSet.get(doorIdValue);
                    if (door) {
                        const doorRetailCostString = get(data, [
                            ItemFields.Fields,
                            door.retail.fieldName,
                            getterParams.context?.isServerRollup ? "number_value" : "string_value",
                        ]);
                        if (doorRetailCostString) {
                            const doorRetailCost = safeParseFloat(doorRetailCostString, 0);
                            totalRetailCostForRow += bulkCount * doorRetailCost;
                        }
                    }
                });

                return totalRetailCostForRow;
            }
        },
        getterParams,
        MetricsKind.TOTAL_RETAIL,
        node.id,
        ColumnTypes.AllDimensionTotal
    );

    if (grandTotalRowRetail > 0 && totalRetail) {
        return (totalRetail / grandTotalRowRetail) * 100;
    }

    return 0;
};
